import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';
import { FontText } from './FontText';
import { localAnalytics } from '../../utils/analytics';

export const ThemeToggle: React.FC = () => {
  const { t } = useTranslation();
  const { theme, themeMode, toggleTheme } = useTheme();
  const onToggleTheme = () => {
    localAnalytics().logEvent('ThemeToggle', {
      themeMode,
    });
    toggleTheme();
  };

  const styles: Record<string, React.CSSProperties> = {
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '15px',
      backgroundColor: theme.colors.overlay,
      border: 'none',
      borderRadius: '8px',
      marginBottom: '10px',
      cursor: 'pointer',
      textAlign: 'left',
      textDecoration: 'none',
      width: '100%',
    },
    toggle: {
      position: 'relative',
      width: '50px',
      height: '24px',
      backgroundColor: themeMode === 'dark' ? theme.colors.accent : '#ccc',
      borderRadius: '24px',
      border: 'none',
      cursor: 'pointer',
      transition: 'background-color 0.3s',
    },
    toggleButton: {
      position: 'absolute',
      top: '2px',
      left: themeMode === 'dark' ? '26px' : '2px',
      width: '20px',
      height: '20px',
      backgroundColor: 'white',
      borderRadius: '50%',
      transition: 'left 0.3s',
    },
  };

  return (
    <button style={styles.container} onClick={onToggleTheme}>
      <FontText style={{ color: theme.colors.text }}>
        {themeMode === 'dark' ? t('theme_dark') : t('theme_light')} {t('theme')}
      </FontText>
      <div style={styles.toggle}>
        <div style={styles.toggleButton} />
      </div>
    </button>
  );
};
